import FiltrosAgendaVista from "../vista/filtrosAgendaVista";
import type { IFiltroAgenda, IFiltrosAgendaCVProps } from "../interfaces";
import { useEffect, useState } from "react";
import ModeloUsuario from "../../../modelos/Usuario";
import type { IUsuario } from "../../../modelos/Usuario/entidades/IUsuario";
import { EnumPerfiles } from "../../../globales/enums/enumPerfiles";
import { estadoInicialFiltroUsuario } from "../../usuarios/interfaces";

const FiltrosAgendaCV: React.FunctionComponent<IFiltrosAgendaCVProps> = ({ filtroAgenda, setFiltroAgenda }) => {
    const modeloUsuario = new ModeloUsuario();

    const [tecnicosCatalogo, setTecnicosCatalogo] = useState<IUsuario[]>([])
    // const [filtro, setFiltro] = useState<IFiltroAgenda>({
    //     Fecha: new Date().toISOString(),
    //     Tecnicos: []
    // });

    useEffect(() => {
        consultarTecnicos();
    }, []);

    const consultarTecnicos = async () => {
        const usuarios = await modeloUsuario.obtenerListaUsuarios(estadoInicialFiltroUsuario);
        setTecnicosCatalogo(usuarios.Data.filter(u => u.PerfilUsuarioId === EnumPerfiles.Tecnico))
    }

    const manejarCambioFiltroAgenda = async (campo: keyof IFiltroAgenda, valor: IFiltroAgenda[keyof IFiltroAgenda]) => {
        // if (campo === 'Tecnicos' && Array.isArray(valor)) {
        //     if (valor.length > 0) {
        //         setListaTecnicosFiltro(valor)
        //     }
        //     else setListaTecnicosFiltro(tecnicosCatalogo)
        // }

        setFiltroAgenda((prevFiltroTarea) => ({
            ...prevFiltroTarea,
            [campo]: valor
        }));
    }
    return (
        <FiltrosAgendaVista
            listaTecnicos={tecnicosCatalogo}
            filtro={filtroAgenda}
            manejarCambioFiltroAgenda={manejarCambioFiltroAgenda}

        />
    )
}

export default FiltrosAgendaCV;